import state from './moduleExternalOrderRequestState'
import mutations from './moduleExternalOrderRequestMutations'
import actions from './moduleExternalOrderRequestActions'
import getters from './moduleExternalOrderRequestGetters'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
